
import React, { useRef } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { toast } from '@/hooks/use-toast';
import PeriodCalculatorForm from './PeriodCalculatorForm';
import PeriodCalculatorResults from './PeriodCalculatorResults';
import { calculatePeriodPredictions } from './periodCalculatorUtils';
import { PeriodPrediction } from './periodCalculatorTypes';

const PeriodCalculator = () => {
  const [results, setResults] = React.useState<{
    predictions?: PeriodPrediction[];
    message?: string;
  }>({});
  
  const calculatorRef = useRef<HTMLDivElement>(null);

  const handleCalculate = (lastPeriod: string, cycleLength: string, periodLength: string) => {
    try {
      const predictions = calculatePeriodPredictions(lastPeriod, cycleLength, periodLength);
      
      if ('error' in predictions) {
        setResults({ message: predictions.error });
        toast({
          title: predictions.title,
          description: predictions.error,
          variant: "destructive"
        });
        return;
      }
      
      setResults({ predictions });
      toast({
        title: "Calculation complete",
        description: "Your period predictions are ready",
      });
    } catch (error) {
      setResults({ message: 'Error calculating period dates. Please check your inputs.' });
      toast({
        title: "Calculation error",
        description: "Error calculating period dates. Please check your inputs.",
        variant: "destructive"
      });
    }
  };

  return (
    <Card className="w-full" ref={calculatorRef}>
      <CardContent className="pt-6">
        <div className="space-y-6">
          <div className="space-y-4">
            <h3 className="text-lg font-medium">Period Calculator</h3>
            <p className="text-sm text-muted-foreground">
              Track and predict your menstrual cycle, fertility window, and ovulation dates.
            </p>
          </div>
          
          <PeriodCalculatorForm 
            calculatorRef={calculatorRef}
            onCalculate={handleCalculate}
            results={results}
          />

          <PeriodCalculatorResults results={results} />
        </div>
      </CardContent>
    </Card>
  );
};

export default PeriodCalculator;
